var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-contract"},[_c('nav-bar',{attrs:{"navBarTitle":"用户协议"}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-detail",attrs:{"id":"contentDetail"},domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }